export function getFileType(file: File) {
  return file.type.split("/")[0];
}
